import 'katex/dist/katex.min.css'; //
// para fórmulas matemáticas
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';

import { llmHtmlSanitizeSchema, rehypeCollapseClobberPrefix } from 'core/utils/sanitizeLlmHtml';

import 'highlight.js/styles/github.css'; // o el tema que prefieras

function Markdown({ children }) {
  // Convertir \(x\) a $x$ antes de procesar
  const processedContent = children.replace(/\\\(/g, '$').replace(/\\\)/g, '$');

  // Configuración personalizada para KaTeX
  const katexOptions = {
    // Opciones de KaTeX que pueden personalizarse
    strict: false,
    trust: false,
    throwOnError: false, // Evita que errores de KaTeX rompan el renderizado
    errorColor: '#cc0000', // Color para errores de fórmulas
    macros: {
      // Aquí podríamos definir macros personalizadas si fuera necesario
    },
  };

  // Opciones para remarkMath - SOLO usar delimitadores que funcionan
  const mathOptions = {
    // Habilitar reconocimiento de todos los delimitadores comunes
    singleDollarTextMath: true, // Habilita $...$ como delimitador de matemáticas
    // Configuración específica para fórmulas inline - SOLO $
    inlineMath: [['$', '$']],
    // Configuración para fórmulas de bloque - SOLO $$
    blockMath: [['$$', '$$']],
  };

  return (
    <div className="markdown-container">
      <ReactMarkdown
        remarkPlugins={[[remarkMath, mathOptions], remarkGfm]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, llmHtmlSanitizeSchema], rehypeCollapseClobberPrefix, [rehypeKatex, katexOptions], rehypeHighlight]}
      >
        {processedContent}
      </ReactMarkdown>
    </div>
  );
}

Markdown.propTypes = {
  children: PropTypes.node.isRequired,
  enableDebug: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslation(['chatbot', 'actions'])(Markdown);
